import { render, staticRenderFns } from "./PendingIssues.vue?vue&type=template&id=6c6a61d3&scoped=true"
import script from "./PendingIssues.vue?vue&type=script&lang=js"
export * from "./PendingIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a61d3",
  null
  
)

export default component.exports